import angular from 'angular'
import moment from 'moment'

import templateUrl from './edit-sgi-id-assignment-modal.component.html'

export const EditSgiIdAssignmentModalComponent = {
    templateUrl,
    controller: EditSgiIdAssignmentController,
    controllerAs: "vm",
    bindings: {
        resolve: "<",
        close: "&",
        dismiss: "&"
    }
}

export const EditSgiIdAssignmentModal = {
    component: "apexEditSgiIdAssignmentModal",
    windowClass: 'xx-dialog pagespinner',
    size: 'lg',
    backdrop: 'static'
}

function EditSgiIdAssignmentController(onboardingApplicationService, utilityService) {
    'ngInject'
    const vm = this;

    vm.$onInit = onInit;
    vm.employment;
    vm.onboardingApplication;
    vm.isAdminView;
    vm.onCancel = onCancel;
    vm.onSave = onSave;
    vm.onEdit = onEdit;
    vm.onChange = onChange;
    vm.onDelete = onDelete;
    vm.editForm;
    vm.errors = [];
    return;

    function onInit() {
        vm.onboardingApplication = angular.copy(vm.resolve.onboardingApplication);
        vm.isAdminView = vm.resolve.isAdminView;
        vm.prestineSgiAssignmentHistories = vm.resolve.sgiAssignmentHistories;
        vm.sgiAssignmentHistories = angular.copy(vm.prestineSgiAssignmentHistories);
    }

    function loadData() {

        const sgiAssignmentHistories = onboardingApplicationService.retrieveEmployeeSgiIdHistory(
            vm.onboardingApplication.IcdOffice.Id, vm.onboardingApplication.EmployeeID)
        utilityService.showLoading();
        sgiAssignmentHistories.catch(angular.noop)
            .then(function (histories) {
                vm.sgiAssignmentHistories = histories;
                vm.editForm.$setPristine();
            }).then(utilityService.hideLoading);
    }

    function updateSgiAssignmentHistory(sgiIdHistory, currentHistory) {

        const nextHistory = sgiIdHistory.reduce(function (nextHistory, other) {
            if (other === currentHistory || moment(other.ActiveStart).isSameOrBefore(currentHistory.ActiveStart)) {
                return nextHistory
            }

            if (!nextHistory || moment(nextHistory.ActiveStart).isSameOrAfter(other.ActiveStart)) {
                return other;
            }
            return nextHistory;
        }, null);
        if (nextHistory && !currentHistory.ActiveEnd) {
            currentHistory.ActiveEnd = moment(nextHistory.ActiveStart).subtract(1, "day").toDate();
            currentHistory.IsUpdated = true;
        }

        const previousHistory = sgiIdHistory.reduce(function (previousPolicy, other) {
            if (other === currentHistory || moment(other.ActiveStart).isSameOrAfter(currentHistory.ActiveStart)) {
                return previousHistory
            }

            if (!previousHistory || moment(previousHistory.ActiveStart).isSameOrBefore(other.ActiveStart)) {
                return other;
            }
            return previousHistory;
        }, null);

        if (previousHistory && !previousHistory.ActiveEnd) {
            previousHistory.ActiveEnd = moment(currentHistory.ActiveStart).subtract(1, "day").toDate();
            previousHistory.IsUpdated = true;
        }
    }

    function validate() {
        // Keep the dates organized in descending order.
        vm.sgiAssignmentHistories.sort(function (a, b) {
            if (a.ActiveStart > b.ActiveStart) {
                return -1;
            }
            if (a.ActiveStart < b.ActiveStart) {
                return 1;
            }
            return 0;
        });

        const isValidHistoryOrder = vm.sgiAssignmentHistories.reduce(function (ag, history, i, a) {
            if (!ag.valid) {
                return ag;
            }

            const valid = !(
                history.ActiveStart && history.ActiveEnd && history.ActiveStart > history.ActiveEnd
                || !history.ActiveEnd && i !== 0
                || !history.ActiveStart && i !== a.length - 1
                || ag.previousStart && history.ActiveEnd >= ag.previousStart);

            return {
                previousStart: history.ActiveStart,
                previousEnd: history.ActiveEnd,
                valid: valid
            };
        }, { previousStart: null, previousEnd: null, valid: true }).valid;

        if (vm.editForm) {
            vm.editForm.$setValidity("historyOrder", isValidHistoryOrder);
        }

        return isValidHistoryOrder;
    }


    function onChange(history) {
        history.IsUpdated = true;
        vm.editForm.$setDirty(true);
        updateSgiAssignmentHistory(vm.sgiAssignmentHistories, history)
        validate();

    }


    function onDelete(history) {
        if (confirm("Are you sure you want to delete?")) {
            if (history.IsNew) {
                const index = vm.sgiAssignmentHistories.indexOf(history);
                vm.sgiAssignmentHistories.splice(index, 1);
            } else {
                utilityService.showLoading();
                onboardingApplicationService.deleteEmployeeSgiIdHistory(history.SgiIdHistoryID)
                    .then(function () {
                        utilityService.hideLoading();
                        loadData();
                    }).catch(function (ex) {
                        utilityService.hideLoading();
                        $.winxnetAlertWindow({ message: "Saving failed: " + utilityService.getExceptionMessage(ex) });
                    });
            }
        }
    }

    function onEdit() {
        vm.editForm.$setDirty(true);
        const newSgiAssignment = {
            IsNew: true,
            SgiId: "",
            ActiveStart: null,
            ActiveEnd: null,
            EmployeeID: vm.onboardingApplication.EmployeeID,
            IcdOfficeID: vm.onboardingApplication.IcdOffice.Id
        };
        vm.sgiAssignmentHistories.unshift(newSgiAssignment);
    }

    function onCancel() {
        vm.dismiss({ $value: 'cancel' });
    }

    function onSave() {

        vm.errors = [];
        utilityService.showLoading();
        const requests = vm.sgiAssignmentHistories.filter(function (history) {
            return history.IsNew || history.IsUpdated
        });
        onboardingApplicationService.upsertEmployeeSgiIdHistory(requests)
            .then(function () {

                utilityService.hideLoading();
                loadData();
            }).catch(function (ex) {
                utilityService.hideLoading();
                console.error(ex);
                Object.keys(ex.data.ModelState).forEach(function (key) {
                    for (let i = 0; i < ex.data.ModelState[key].length; i++) {
                        vm.errors.push(ex.data.ModelState[key][i]);
                    }
                })
                $.winxnetAlertWindow({ message: "Saving failed: " + utilityService.getExceptionMessage(ex) });
            });

    }

}
